import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "flex flex-col text-sm" }
const _hoisted_3 = { class: "font-medium text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "ml-2 inline-flex items-center rounded-full bg-royal-blue-50 px-1.5 py-0.5 text-xs font-medium text-royal-blue-500 ring-1 ring-royal-blue-700/10 ring-inset"
}
const _hoisted_5 = {
  key: 1,
  class: "ml-2 inline-flex items-center rounded-full bg-royal-blue-50 px-1.5 py-0.5 text-xs font-medium text-royal-blue-500 ring-1 ring-royal-blue-700/10 ring-inset"
}
const _hoisted_6 = {
  key: 1,
  class: "ml-2 inline-flex items-center rounded-full bg-royal-blue-50 px-1.5 py-0.5 text-xs font-medium text-royal-blue-500 ring-1 ring-royal-blue-700/10 ring-inset"
}
const _hoisted_7 = {
  key: 2,
  class: "ml-2 mt-1 sm:mt-0 inline-flex items-center rounded-full bg-gradient-to-r from-purple-50 to-pink-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-purple-200 ring-inset"
}
const _hoisted_8 = { class: "hidden sm:inline" }
const _hoisted_9 = { class: "sm:hidden" }
const _hoisted_10 = { class: "text-gray-500" }
const _hoisted_11 = { class: "block sm:inline" }
const _hoisted_12 = {
  key: 0,
  class: "hidden sm:mx-1 sm:inline",
  "aria-hidden": "true"
}
const _hoisted_13 = {
  key: 1,
  class: "block sm:inline"
}
const _hoisted_14 = {
  key: 2,
  class: "hidden sm:mx-1 sm:inline",
  "aria-hidden": "true"
}
const _hoisted_15 = {
  key: 3,
  class: "block sm:inline"
}
const _hoisted_16 = {
  key: 4,
  class: "hidden sm:mx-1 sm:inline",
  "aria-hidden": "true"
}
const _hoisted_17 = {
  key: 5,
  class: "block sm:inline"
}
const _hoisted_18 = { class: "mt-2 flex text-base sm:text-sm sm:mt-0 sm:ml-4 flex-col sm:justify-center sm:text-right" }
const _hoisted_19 = { class: "font-medium text-gray-900" }
const _hoisted_20 = {
  key: 0,
  class: "flex flex-col sm:flex-row sm:items-center gap-1"
}
const _hoisted_21 = { class: "flex items-center gap-1.5 sm:gap-1" }
const _hoisted_22 = { class: "text-gray-400 text-sm sm:text-xs" }
const _hoisted_23 = { class: "text-purple-600 font-bold text-base sm:text-sm" }
const _hoisted_24 = { class: "text-gray-500 text-sm sm:text-sm" }
const _hoisted_25 = { class: "ml-1 text-gray-500 sm:ml-0" }
const _hoisted_26 = {
  key: 0,
  class: "text-gray-500 text-sm sm:text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.item.key === _ctx.selected?.key ? 'border-royal-blue-500 ring-2 ring-royal-blue-500' : 'border-gray-300', 'relative block cursor-pointer rounded-lg border bg-white px-6 py-4 shadow-xs focus:outline-hidden sm:flex sm:justify-between'])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.item.title) + " ", 1),
          (!(_ctx.blackFridayUpgrade && _ctx.blackFridayUpgrade.can_upgrade && _ctx.period === 1))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.item.key == _ctx.subscription?.key && _ctx.period === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('subscription_plan.current')), 1))
                  : _createCommentVNode("", true),
                (!(_ctx.item.key == _ctx.subscription?.key && _ctx.period === 1) && _ctx.item.selected)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "🔥 " + _toDisplayString(_ctx.$t('subscription_plan.most_popular')), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.hasFaceRecognition)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "✨ " + _toDisplayString(_ctx.$t('subscription_plan.face_recognition')), 1))
            : _createCommentVNode("", true),
          (_ctx.blackFridayUpgrade && _ctx.blackFridayUpgrade.can_upgrade && _ctx.period === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mr-1" }, "⚡️", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('subscription.black_friday.discount')), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('subscription.black_friday.discount_short')), 1),
                (_ctx.hasBonusDays)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mx-1" }, "+", -1)),
                      _createElementVNode("span", null, "🎁 " + _toDisplayString(_ctx.$t('subscription.black_friday.bonus_days', {days: _ctx.blackFridayUpgrade.bonus_days})), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(Math.round(_ctx.item.limit / (1024 * 1024 * 1024) * 100) / 100) + " " + _toDisplayString(_ctx.$t('subscription_plan.gb_storage')), 1),
          _cache[2] || (_cache[2] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
          (_ctx.item.key !== 'free')
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "·"))
            : _createCommentVNode("", true),
          _cache[3] || (_cache[3] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
          (_ctx.item.key !== 'free')
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('subscription_plan.up_to_video')), 1))
            : _createCommentVNode("", true),
          _cache[4] || (_cache[4] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
          (_ctx.item.key !== 'free')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "·"))
            : _createCommentVNode("", true),
          _cache[5] || (_cache[5] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
          (_ctx.item.key !== 'free')
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('subscription_plan.unlimited_storage')), 1))
            : _createCommentVNode("", true),
          (_ctx.item.key === 'free')
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "·"))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
          (_ctx.item.key === 'free')
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('subscription_plan.gallery_storage_60_days')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("span", _hoisted_18, [
      _createElementVNode("span", _hoisted_19, [
        (_ctx.blackFridayUpgrade && _ctx.blackFridayUpgrade.can_upgrade && _ctx.period === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("s", _hoisted_22, _toDisplayString(_ctx.formatPrice(_ctx.originalPricePerMonth)) + " " + _toDisplayString(_ctx.currencySymbol), 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.formatPrice(_ctx.pricePerMonth)) + " " + _toDisplayString(_ctx.currencySymbol), 1)
              ]),
              _createElementVNode("span", _hoisted_24, "/ " + _toDisplayString(_ctx.$t('subscription_plan.month')), 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.formatPrice(_ctx.pricePerMonth)) + " " + _toDisplayString(_ctx.currencySymbol) + " ", 1),
              _createElementVNode("span", _hoisted_25, "/ " + _toDisplayString(_ctx.$t('subscription_plan.month')), 1)
            ], 64))
      ]),
      (_ctx.period == 12)
        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.formatPrice(_ctx.planPriceForPeriod)) + " " + _toDisplayString(_ctx.currencySymbol) + " / " + _toDisplayString(_ctx.$t('subscription_plan.year')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", {
      class: _normalizeClass([_ctx.item.key === _ctx.subscription?.key ? 'border' : 'border-2', _ctx.item.key === _ctx.selected?.key ? 'border-royal-blue-500' : 'border-transparent', 'pointer-events-none absolute -inset-px rounded-lg']),
      "aria-hidden": "true"
    }, null, 2)
  ], 2))
}